<template>
  <div class="bits-store-report">
    <div class="filters">
      <label>
        From:
        <input type="date" v-model="startTime" />
      </label>
      <label>
        To:
        <input type="date" v-model="endTime" />
      </label>
    </div>
    <p class="summary">
      <strong>{{ totalBits }}</strong> bits total
      <br />
      <strong>{{ totalReceipts }}</strong> transactions made
    </p>
    <div class="graph-bits">
      <BarChart
        :height="300"
        :chartData="chartData"
        :options="chartOpts" />
    </div>
    <div class="transactions">
      <div v-for="day of days" :key="day.date">
        <template v-if="day.receipts.length > 0">
          <strong>{{ day.date | moment('YYYY-MM-DD') }}</strong>
          &ndash;
          {{ day.receipts.length }} transactions, {{ day.total }} bits
          <div v-for="receipt of day.receipts" :key="receipt.transactionId">
            &middot;
            + {{ receipt.product.cost.amount }}
            &ndash;
            {{ receipt.product.displayName }}
          </div>
          <br />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import BarChart from './graphs/BarChart.vue'
import { mapState } from 'vuex'

export default {
  name: 'BitStoreReport',
  components: { BarChart },

  data () {
    const startTime = moment().subtract(1, 'month').format('YYYY-MM-DD')
    const endTime = moment().format('YYYY-MM-DD')
    return {
      startTime,
      endTime,
      chartOpts: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        elements: {
          rectangle: {
            backgroundColor: 'mediumorchid',
            borderWidth: 1,
            borderColor: 'rgba(0, 0, 0, 0.25)'
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0
              }
            }
          ],
          xAxes: [
            {
              type: 'time',
              time: {
                minUnit: 'day'
              }
            }
          ]
        }
      }
    }
  },

  computed: {
    ...mapState(['bitsReceipts']),
    days () {
      const start = moment(this.startTime)
      const end = moment(this.endTime)
      const duration = moment.duration(end.diff(start)).asDays()
      const days = []

      for (let i = 0; i <= duration; i++) {
        const s = start.clone().add(i, 'days')
        const e = s.clone().add(1, 'day')
        const day = {
          date: s.format('Y-MM-DD'),
          total: 0,
          receipts: []
        }
        this.bitsReceipts
          .filter((receipt) => {
            const ts = moment(receipt.time, 'YYYY-MM-DD HH:mm:ss.SSSSSSSSS Z')
            return ts.isSameOrAfter(s) && ts.isBefore(e)
          })
          .forEach((receipt) => {
            day.total += receipt.product.cost.amount
            day.receipts.push(receipt)
          })
        days.push(day)
      }
      days.reverse()
      return days
    },

    chartData () {
      const labels = this.days.map((day) => day.date)
      const dataBits = this.days.map((day) => day.total)
      return {
        labels,
        datasets: [
          {
            label: 'Bits',
            data: dataBits
          }
        ]
      }
    },

    totalBits () {
      return this.days.reduce((a, b) => a + b.total, 0)
    },
    totalReceipts () {
      return this.days.reduce((a, b) => a + b.receipts.length, 0)
    }
  },

}
</script>

<style scoped>
</style>
